/**
 * Free sample pack — the DOM side. Keeps the cart holding the right free pack:
 * after every cart change it reads /cart.js, asks FreeSample.plan() (assets/free-sample.js)
 * for the next step, applies it, and repeats until there is nothing to do.
 * Then re-renders the drawer so the bar, the FREE tag and the totals catch up.
 *
 * Also wires the drawer's "Swap" and "Add it" buttons and the pack picker.
 * Config (threshold + the 11 bundle variant ids) comes from #FreeSampleConfig,
 * rendered by snippets/free-sample-bar.liquid inside the drawer.
 */
(function () {
  var STORE = 'fanolaFreeSample';
  var running = false, again = false, ownChange = false;
  function dbg() { try { if (localStorage.getItem('fsDebug')) console.log.apply(console, ['[free-sample]'].concat([].slice.call(arguments))); } catch (e) {} }

  function state() {
    try { return JSON.parse(sessionStorage.getItem(STORE)) || {}; } catch (e) { return {}; }
  }
  function save(s) {
    try { sessionStorage.setItem(STORE, JSON.stringify(s)); } catch (e) {}
  }
  function config() {
    var el = document.getElementById('FreeSampleConfig');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function json(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }

  function isCartPage() { return /^\/cart\/?$/.test(location.pathname); }

  var SECTION = 'cart-drawer';

  /** Paint a freshly rendered cart-drawer section into the page (no extra request). */
  function paint(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#CartDrawer'), dest = document.querySelector('#CartDrawer');
    var drawer = document.querySelector('cart-drawer'), freshDrawer = doc.querySelector('cart-drawer');
    // swap only the inner #CartDrawer: the overlay's click-to-close listener lives on the outer element
    if (fresh && dest) dest.innerHTML = fresh.innerHTML;
    if (drawer && freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
    // the drawer title carries the count: "Your cart (4)"
    var h = doc.querySelector('cart-drawer h4'), count = document.getElementById('CartCount');
    var m = h && h.textContent.match(/\((\d+)\)/);
    if (m && count) count.textContent = m[1];
    if (typeof window.initCartUpsells === 'function') window.initCartUpsells();
  }

  function rerender() {
    if (isCartPage()) { location.reload(); return Promise.resolve(); }
    return fetch('/cart?section_id=' + SECTION).then(function (r) { return r.text(); }).then(paint);
  }

  /**
   * Cart writes ask Shopify to render the drawer in the same response (Section Rendering
   * API), so a change costs one request, not three. Every cart request on this store is
   * slowed by another app wrapping fetch (~1s each), so request count is what matters.
   */
  function write(url, body) {
    if (!isCartPage()) body.sections = SECTION;
    return json(url, body).then(function (res) { return (res && res.sections && res.sections[SECTION]) || null; });
  }

  /** Apply one planned step. Resolves to the re-rendered drawer HTML (or null). */
  function apply(step) {
    var s = state();
    if (step.action === 'add') {
      s.added = step.handle; save(s);
      return write('/cart/add.js', { items: [{ id: step.variantId, quantity: 1, properties: { _free_sample: '1' } }] });
    }
    if (step.action === 'remove' || step.action === 'set') {
      return write('/cart/change.js', { id: step.key, quantity: step.action === 'set' ? step.quantity : 0 });
    }
    return Promise.resolve(null);
  }

  function finish(html) {
    if (isCartPage()) { location.reload(); return Promise.resolve(); }
    if (html) { paint(html); return Promise.resolve(); }
    return rerender();
  }

  /** Bring the cart in line with the plan; at most 4 steps so a fight with another script can't loop. */
  function sync() {
    var cfg = config();
    if (!cfg || !window.FreeSample) return Promise.resolve();
    if (running) { again = true; dbg('busy, queued'); return Promise.resolve(); }
    running = true;
    var changed = false, steps = 0, lastHtml = null;
    function loop() {
      return json('/cart.js').then(function (cart) {
        var s = state();
        var hasFree = cart.items.some(function (i) { return i.properties && i.properties._free_sample; });
        // the customer took the pack out themselves while still qualifying: respect it
        if (s.present && !hasFree && !s.removing) {
          var ids = cfg.bundles.map(function (b) { return Number(b.variantId); });
          if (window.FreeSample.qualifyingSubtotal(cart.items, ids) >= cfg.threshold) { s.declined = true; }
        }
        s.present = hasFree; s.removing = false; save(s);
        var step = window.FreeSample.plan(cart, cfg, s);
        dbg('step', JSON.stringify(step), JSON.stringify(s));
        if (step.action === 'none' || steps++ >= 4) return;
        if (step.action === 'remove') { s.removing = true; save(s); }
        return apply(step).then(function (html) { changed = true; lastHtml = html; return loop(); });
      });
    }
    return loop().then(function () {
      if (changed) { ownChange = true; return finish(lastHtml).then(settle); }
    }).catch(function (e) { console.warn('[free-sample]', e); }).then(function () {
      ownChange = false; running = false;
      if (again) { again = false; return sync(); }
    });
  }

  /**
   * The theme re-renders the drawer on its own after a cart change; when its (older)
   * response lands after ours it paints a cart without the free pack. Check once the
   * dust settles and repaint if the drawer disagrees with the cart.
   */
  function settle() {
    if (isCartPage()) return;
    return new Promise(function (res) { setTimeout(res, 1200); }).then(function () {
      return json('/cart.js');
    }).then(function (cart) {
      var inCart = cart.items.some(function (i) { return i.properties && i.properties._free_sample; });
      var shown = !!document.querySelector('#CartDrawer [data-fs-key]');
      if (inCart !== shown) return rerender();
    });
  }

  function openPicker(currentHandle) {
    var p = document.querySelector('[data-fs-picker]');
    if (!p) return;
    p.querySelectorAll('.fs-opt').forEach(function (o) {
      o.classList.toggle('is-current', o.getAttribute('data-fs-handle') === currentHandle);
    });
    p.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var swap = t.closest('[data-fs-swap]');
    if (swap) { e.preventDefault(); openPicker(swap.getAttribute('data-fs-current')); return; }
    if (t.closest('[data-fs-close]')) { e.preventDefault(); var p = t.closest('[data-fs-picker]'); if (p) p.hidden = true; return; }
    var add = t.closest('[data-fs-add]');
    if (add) {
      // Direct, not via sync(): a sync already in flight holds the old "declined" state
      // and would write it back over this click.
      e.preventDefault();
      add.classList.add('fs-busy');
      var cfgA = config();
      json('/cart.js').then(function (cart) {
        var s = state(); s.declined = false; save(s);
        var step = window.FreeSample.plan(cart, cfgA, s);
        return step.action === 'add' ? apply(step) : null;
      }).then(function (html) {
        var s = state(); s.declined = false; s.present = true; s.removing = false; save(s);
        ownChange = true;
        return finish(html).then(settle);
      }).catch(function (err) { console.warn('[free-sample] add', err); })
        .then(function () { ownChange = false; });
      return;
    }
    var opt = t.closest('.fs-opt');
    if (opt && !opt.disabled) {
      e.preventDefault();
      var handle = opt.getAttribute('data-fs-handle');
      var variantId = Number(opt.getAttribute('data-fs-variant'));
      var st = state(); st.preferred = handle; st.declined = false; st.removing = true; save(st);
      // Show the choice at once: close the picker and put the new pack on the line while it saves.
      var picker = opt.closest('[data-fs-picker]');
      if (picker) picker.hidden = true;
      var lineEl = document.querySelector('[data-fs-key]');
      var key = lineEl && lineEl.getAttribute('data-fs-key');
      var row = lineEl && (lineEl.closest('li, tr, .cart-item') || lineEl);
      if (row) {
        row.classList.add('fs-pending');
        var img = opt.querySelector('img'), pic = row.querySelector('.gitem-img, img');
        if (img && pic) { if (pic.tagName === 'IMG') pic.src = img.src; else pic.style.backgroundImage = 'url(' + img.src + ')'; }
        var name = row.querySelector('.pName, .grid-view-item__title b');
        if (name) name.textContent = 'Fanola Sample Bundle - ' + opt.textContent.trim();
      }
      var removeOld = key
        ? json('/cart/change.js', { id: key, quantity: 0 })
        : json('/cart.js').then(function (cart) {
            var old = cart.items.filter(function (i) { return i.properties && i.properties._free_sample; });
            return old.length ? json('/cart/change.js', { id: old[0].key, quantity: 0 }) : null;
          });
      ownChange = true;
      removeOld.then(function () {
        return write('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _free_sample: '1' } }] });
      }).then(function (html) {
        var s2 = state(); s2.present = true; s2.removing = false; save(s2);
        return finish(html);
      }).catch(function (err) { console.warn('[free-sample] swap', err); return rerender(); })
        .then(function () { ownChange = false; });
    }
  });

  // React to every way this theme changes the cart.
  var debounce;
  function schedule() {
    dbg('schedule', ownChange ? '(ignored: own change)' : '');
    if (ownChange) return;
    clearTimeout(debounce);
    debounce = setTimeout(sync, 250);
  }
  // vendor.js declares these as top-level `function subscribe` / `const PUB_SUB_EVENTS`:
  // global bindings, but the const is NOT a window property - reference them bare.
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  } catch (e) {}
  document.addEventListener('cart:refresh', schedule);
  // The theme's own cartUpdate publish is not reliable: CartItems.updateQuantity calls
  // trapFocus() first, which throws on some drawer states, and the publish is skipped.
  // So also watch the network: any finished cart write by anyone (theme, upsell, apps).
  try {
    new PerformanceObserver(function (list) {
      var hit = list.getEntries().some(function (e) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(e.name); });
      if (!hit || ownChange) return;
      // a change that lands mid-sync may not be ours: queue one more pass rather than drop it
      if (running) { again = true; return; }
      schedule();
    }).observe({ type: 'resource', buffered: false });
  } catch (e) {}
  document.addEventListener('DOMContentLoaded', schedule);
  if (document.readyState !== 'loading') schedule();

  window.FreeSampleCart = { sync: sync };
})();
